<script setup>

</script>

<template>
<div class="border border-[#EBE1E1] bg-white rounded-xl px-[6px] py-[4px] w-max text-[9px] leading-[6px] text-center text-[#727373]">
    <a href="https://dailygrow.ru/" target="_blank">Сделано в DailyGrow</a>
</div>
</template>

<style scoped>

</style>
